import mastercardMark from '../../assets/images/Mastercard.svg';
import maestroMark from '../../assets/images/Maestro.svg';
import applePayMark from '../../assets/images/Apple_Pay_Mark_RGB_041619.svg';
import visaMark from '../../assets/images/Visa.svg';
import React from 'react';

function PaymentOptionMarks({ showApplePay }) {
  return (
    <div className={'payment_option_marks'}>
      <img src={mastercardMark} alt={'Mastercard Logo'} />
      {/*<img src={americanExpressMark} alt={'American Express Logo'} />*/}
      {showApplePay && <img src={applePayMark} alt={'Apple Pay Logo'} />}
      <img src={visaMark} alt={'Visa Logo'} />
      <img src={maestroMark} alt={'Maestro Logo'} />
    </div>
  );
}

export default PaymentOptionMarks;
